'use client';

import { useState, useEffect, useRef } from 'react';
import { useRouter } from "next/navigation";
import LandingPageHeader from '@/components/landingpageHeader';
import LandingPageFooter from '@/components/landingpageFooter';
import SignupModal from '@/components/signupModel';

export default function WebsiteMakerHomepage() {
    const router = useRouter();
    const [showLoadingGoogleLOgin, setShowLoadingGoogleLogin] = useState(false)
    const [htmlContent, setHtmlContent] = useState("")
    const [isLoading, setLoading] = useState(false);
    const iframeRef = useRef(null);
    const [isDark, setIsDark] = useState(true)
    const [isModalOpen, setModalOpen] = useState(false);
    const [isMobile, setIsMobile] = useState(false)

    const slideIndex = useRef(0);



    useEffect(() => {
        const blob = new Blob([htmlContent], { type: "text/html" });
        const url = URL.createObjectURL(blob);

        if (iframeRef.current) {
            iframeRef.current.src = url;
        }

        return () => {
            URL.revokeObjectURL(url); // memory cleanup
        };
    }, [htmlContent]);

    useEffect(() => {
        if (typeof window !== "undefined") {
            const ls = localStorage.getItem("theme"); // 'dark' | 'light' | null
            const prefersDark = window.matchMedia("(prefers-color-scheme: dark)").matches;
            const dark = ls ? ls === "dark" : prefersDark;
            document.documentElement.classList.toggle("dark", dark);
        }
    }, []);

    // Inside your component
    const handleAuthClick = (e) => {
        e.preventDefault();
        if (typeof window !== "undefined") { // ensures client-side
            const token = localStorage.getItem("auth_token");
            if (token) {
                router.push(`/`);
            } else {
                // setModalOpen(true);
                router.push(`/`);
            }
        }
    };


    useEffect(() => {
        const track = document.querySelector(".track"); // or use a ref if in React
        if (!track) return; // prevent crash if not found

        const items = track.children;
        const clones = [];

        Array.from(items).forEach(item => {
            const clone = item.cloneNode(true);
            clones.push(clone);
        });

        clones.forEach(clone => {
            track.appendChild(clone);
        });
    }, []);
    const design = (

        <div className="">
            <div className={`antialiased font-sans ${isDark ? "bg-[#0B1020] text-slate-100" : "bg-slate-50 text-slate-900"
                }`}>
                <section
                    className={`relative overflow-hidden ${isDark ? "bg-slate-900" : "bg-white"
                        }`}
                >
                    <div
                        className={`pointer-events-none absolute inset-0 ${isDark ? "opacity-[0.06]" : "opacity-[0.035]"
                            }`}
                        style={{
                            background: !isDark ? `linear-gradient(to right, currentColor 1px, transparent 1px) 0 0/40px 40px, 
                   linear-gradient(to bottom, currentColor 1px, transparent 1px) 0 0/40px 40px` : '',
                            color: isDark ? "#fff" : "#0f172a",
                        }}
                    ></div>

                    <div className="absolute inset-x-0 top-0 h-1 bg-gradient-to-r from-indigo-500 via-violet-500 to-fuchsia-500"></div>

                    <div className="relative max-w-5xl mx-auto px-6 lg:px-8 py-24 md:py-28 text-center">
                        <span
                            className={`inline-flex items-center gap-2 rounded-full border px-3 py-1 text-xs font-medium ${isDark
                                ? "border-white/10 text-slate-300"
                                : "border-slate-200/70 text-slate-600"
                                }`}
                        >
                            ✨ New • No-code AI
                        </span>

                        <h1
                            className={`mt-5 text-4xl md:text-5xl font-extrabold leading-tight ${isDark ? "text-white" : "text-slate-900"
                                }`}
                        >
                            AI Website Builder –
                            <span className="bg-gradient-to-r from-indigo-600 via-violet-600 to-fuchsia-600 bg-clip-text text-transparent">
                                {" "}Create Stunning, Responsive Web Pages {" "}
                            </span>
                            with Just a Prompt
                        </h1>

                        <p
                            className={`mt-6 text-lg md:text-xl leading-relaxed max-w-3xl mx-auto ${isDark ? "text-slate-300" : "text-slate-700"
                                }`}
                        >
                            Build SEO-friendly, mobile-ready websites in minutes using AI. No coding,
                            no templates – just your ideas and a simple prompt. If you’re searching
                            for the best free AI website builder or the most intuitive AI website
                            creator,{" "}
                            <strong className={isDark ? "text-white" : "text-slate-900"}>Varnz</strong>{" "}
                            has you covered.
                        </p>

                        <div className="mt-8 flex flex-wrap justify-center gap-4">
                            <button
                                onClick={handleAuthClick}
                                // onClick={() => {
                                //     if (typeof window !== "undefined") {
                                //         const token = localStorage.getItem("auth_token");
                                //         if (token) {
                                //             router.push(`/`)
                                //         } else {
                                //             setModalOpen(true);
                                //         }
                                //     }
                                //     }}
                                className="px-6 py-3 rounded-xl font-semibold shadow-lg hover:shadow-xl transition bg-gradient-to-r from-indigo-600 to-violet-600 text-white cursor-pointer"
                            >
                                🚀 Start Building for Free
                            </button>
                        </div>

                        <div
                            className={`mt-6 flex flex-wrap justify-center gap-6 text-sm ${isDark ? "text-slate-400" : "text-slate-500"
                                }`}
                        >
                            <span className="flex text-lg items-center gap-2">⭐ 4.9/5 rating</span>
                            <span className="flex text-lg items-center gap-2">⚡ Build in under 60 sec</span>
                            <span className="flex text-lg items-center gap-2">🌍 Used in 120+ countries</span>
                        </div>
                    </div>
                </section>


                <section
                    id="how"
                    className={`${isDark ? "bg-slate-800" : "bg-indigo-50"} py-20`}
                >
                    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 grid md:grid-cols-[320px_1fr] gap-12 items-start">
                        <div>
                            <h2
                                className={`text-3xl md:text-4xl font-extrabold tracking-tight ${isDark ? "text-white" : "text-slate-900"
                                    }`}
                            >
                                How the AI Page Generator Works
                            </h2>
                            <p className={`mt-4 ${isDark ? "text-slate-300" : "text-slate-600"}`}>
                                From prompt to export in four simple steps—fast, consistent, and
                                SEO-ready.
                            </p>
                            <div className="mt-6 flex flex-wrap gap-2">
                                {[
                                    "Add pricing table",
                                    "Make it minimalist",
                                    "Insert contact form",
                                ].map((text, i) => (
                                    <span
                                        key={i}
                                        className={`px-3 py-1 rounded-full text-sm ring-1 ${isDark
                                            ? "bg-white/5 ring-white/10"
                                            : "bg-white/70 ring-slate-300/70"
                                            }`}
                                    >
                                        {text}
                                    </span>
                                ))}
                            </div>
                        </div>

                        <div className="relative">
                            <div
                                className={`absolute left-5 top-0 bottom-0 w-px ${isDark ? "bg-white/10" : "bg-slate-200"
                                    }`}
                            ></div>

                            <ol className="space-y-8">
                                {[
                                    {
                                        step: "1",
                                        title: "Enter Your Prompt",
                                        desc: 'E.g., “Build a landing page for a fitness app with a pricing table and reviews”.',
                                    },
                                    {
                                        step: "2",
                                        title: "AI Creates Your Web Page",
                                        desc: "It writes the content, designs the layout, and ensures it’s mobile-responsive with the efficiency of the ",
                                        span: "best free AI website builder",
                                    },
                                    {
                                        step: "3",
                                        title: "Edit with More Prompts",
                                        desc: 'Want changes? Just say it. “Add a contact form” or “Make it minimalist” — it’s done instantly with the flexibility of our ',
                                        span: "AI website creator",
                                    },
                                    {
                                        step: "4",
                                        title: "Download or Share",
                                        list: [
                                            "Preview your page online",
                                            "Download the full HTML/CSS",
                                            "Edit again anytime from your My Account area",
                                        ],
                                    },
                                ].map((item, i) => (
                                    <li key={i} className="relative flex gap-6">
                                        <div
                                            className={`relative z-10 flex h-10 w-10 flex-shrink-0 items-center justify-center rounded-full ${isDark ? "bg-slate-800" : "bg-white"
                                                } ring-2 ring-indigo-500 text-indigo-600 font-semibold`}
                                        >
                                            {item.step}
                                        </div>
                                        <div
                                            className={`flex-1 rounded-xl p-5 backdrop-blur-xl ring-1 shadow-sm ${isDark
                                                ? "bg-white/5 ring-white/10"
                                                : "bg-white/70 ring-black/5"
                                                }`}
                                        >
                                            <h3
                                                className={`text-lg md:text-xl font-semibold ${isDark ? "text-white" : "text-slate-900"
                                                    }`}
                                            >
                                                {item.title}
                                            </h3>
                                            {item.desc && (
                                                <p
                                                    className={`mt-1 ${isDark ? "text-slate-300" : "text-slate-600"
                                                        }`}
                                                >
                                                    {item.desc}
                                                    {item.span && (
                                                        <span className="font-medium">{item.span}</span>
                                                    )}
                                                </p>
                                            )}
                                            {item.list && (
                                                <ul
                                                    className={`mt-2 space-y-2 ${isDark ? "text-slate-300" : "text-slate-600"
                                                        }`}
                                                >
                                                    {item.list.map((li, idx) => (
                                                        <li key={idx} className="flex gap-2">
                                                            <span className="select-none">•</span> {li}
                                                        </li>
                                                    ))}
                                                </ul>
                                            )}
                                        </div>
                                    </li>
                                ))}
                            </ol>
                        </div>
                    </div>
                </section>

                <section id="pricing" className="py-16 md:py-24">
                    <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
                        <div className="mb-6 flex justify-center">
                            <div className="h-14 w-14 flex items-center justify-center rounded-full bg-gradient-to-br from-indigo-500 to-violet-600 text-white text-2xl shadow-lg">
                                💳
                            </div>
                        </div>

                        <h2
                            className={`text-3xl md:text-4xl font-extrabold ${isDark ? "text-white" : "text-slate-900"
                                }`}
                        >
                            Credit-Based Pricing – Simple & Flexible
                        </h2>
                        <p
                            className={`mt-3 text-lg ${isDark ? "text-slate-300" : "text-slate-600"
                                }`}
                        >
                            Pay only for what you use. No subscriptions. No expiry.
                        </p>

                        <div
                            className={`mt-10 max-w-md mx-auto backdrop-blur-xl rounded-2xl p-8 ring-1 shadow-md ${isDark ? "bg-white/5 ring-white/10" : "bg-white/70 ring-black/5"
                                }`}
                        >
                            <ul className="space-y-4 text-left">
                                <li className="flex gap-3">
                                    <span className="text-indigo-500">✔</span>
                                    <span>
                                        2 Credits <strong>Free</strong>
                                    </span>
                                </li>
                                <li className="flex gap-3">
                                    <span className="text-indigo-500">✔</span>
                                    <span>
                                        <strong>One Page</strong> = 1 credit
                                    </span>
                                </li>
                                <li className="flex gap-3">
                                    <span className="text-indigo-500">✔</span>
                                    <span>
                                        Use credits across <strong>web page builder</strong>, greeting cards,
                                        and upcoming Varnz AI tools
                                    </span>
                                </li>
                                <li className="flex gap-3">
                                    <span className="text-indigo-500">✔</span>
                                    <span>
                                        <strong>No subscription</strong> needed – credits never expire
                                    </span>
                                </li>
                            </ul>

                            <div className="mt-8">
                                <a
                                    href="#signup"
                                    data-cta="signup"
                                    // onClick={(e) => {
                                    //     e.preventDefault()
                                    //     const token = localStorage.getItem("auth_token");
                                    //     if (token) {
                                    //         router.push(`/`)
                                    //     } else {
                                    //         setModalOpen(true);
                                    //     }
                                    // }}
                                    onClick={handleAuthClick}
                                    className="inline-flex items-center justify-center w-full rounded-full px-5 py-3 bg-gradient-to-r from-indigo-600 to-violet-600 text-white font-semibold shadow-lg hover:shadow-2xl transition"
                                >
                                    Get Started with Credits
                                </a>
                            </div>
                        </div>
                    </div>
                </section>



                <section
                    id="features"
                    className={`py-16 md:py-24 bg-gradient-to-b ${isDark
                        ? "from-slate-900 via-slate-900 to-slate-900"
                        : "from-indigo-50 via-white to-indigo-50"
                        }`}
                >
                    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
                        <div className="max-w-3xl mb-10">
                            <h2 className="font-display text-2xl md:text-4xl font-extrabold tracking-tight">
                                Key Features of the Varnz AI Page Builder
                            </h2>
                            <p className={`mt-4 ${isDark ? "text-slate-300" : "text-slate-600"}`}>
                                Everything you need to launch fast with confidence.
                            </p>
                        </div>

                        <div className="mt-10 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6 md:gap-8">
                            {[
                                {
                                    icon: "🪄",
                                    title: "AI Website Creation with Prompt-Based Input",
                                    desc: `No drag-and-drop. No coding. Just describe your page and let AI build it.
            Perfect for anyone needing a reliable AI website maker.`,
                                },
                                {
                                    icon: "📈",
                                    title: "SEO-Optimized & Mobile-Ready Pages",
                                    desc: `Pages are structured with clean, semantic code for fast load times and great SEO performance.`,
                                },
                                {
                                    icon: "✏️",
                                    title: "Full Control with Prompt-Based Editing",
                                    desc: `Modify layout, text, sections, or styles using simple instructions—no technical skills needed.`,
                                },
                                {
                                    icon: "🧰",
                                    title: "One Account, Multiple Tools",
                                    desc: `Your credits work across all Varnz AI tools—including our AI greeting card generator and future services.`,
                                },
                                {
                                    icon: "🔒",
                                    title: "Permanent Access to Created Pages",
                                    desc: `Revisit, re-edit, and redownload your pages anytime from your dashboard.`,
                                },
                            ].map((feature, i) => (
                                <div
                                    key={i}
                                    className={`group rounded-2xl p-6 md:p-8 backdrop-blur-xl ring-1 shadow-sm hover:shadow-xl transition ${isDark
                                        ? "bg-white/5 ring-white/10"
                                        : "bg-white/70 ring-black/5"
                                        }`}
                                >
                                    <div className="mb-4 inline-flex h-11 w-11 items-center justify-center rounded-xl bg-gradient-to-br from-indigo-500 to-violet-600 text-white">
                                        {feature.icon}
                                    </div>
                                    <h3
                                        className={`text-lg md:text-xl font-semibold ${isDark ? "text-white" : "text-slate-900"
                                            }`}
                                    >
                                        {feature.title}
                                    </h3>
                                    <p
                                        className={`mt-2 ${isDark ? "text-slate-300" : "text-slate-600"
                                            }`}
                                    >
                                        {feature.desc}
                                    </p>
                                </div>
                            ))}
                        </div>
                    </div>
                </section>





                <section id="use-cases" className="py-16 md:py-24">
                    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 grid md:grid-cols-[320px_1fr] gap-12 items-start">

                        <div>
                            <h2
                                className={`text-3xl md:text-4xl font-extrabold tracking-tight ${isDark ? "text-white" : "text-slate-900"
                                    }`}
                            >
                                Use Cases
                            </h2>
                            <p
                                className={`mt-3 ${isDark ? "text-slate-300" : "text-slate-600"}`}
                            >
                                From quick campaigns to full portfolios—Varnz AI adapts to your needs instantly.
                            </p>
                            <button
                                // onClick={() => {
                                //     const token = localStorage.getItem("auth_token");
                                //     if (token) {
                                //         router.push(`/`)
                                //     } else {
                                //         setModalOpen(true);
                                //     }
                                // }}
                                onClick={handleAuthClick}
                                className="mt-6 inline-flex items-center justify-center px-6 py-3 rounded-xl font-semibold shadow-lg bg-gradient-to-r from-indigo-500 to-violet-600 text-white hover:shadow-xl transition cursor-pointer"
                            >
                                Start Building Now
                            </button>
                        </div>

                        <div className="relative">
                            <div
                                className={`absolute left-5 top-0 bottom-0 w-px ${isDark ? "bg-white/10" : "bg-slate-200"
                                    }`}
                            ></div>

                            <ol className="space-y-8">
                                {[
                                    {
                                        icon: "🚀",
                                        title: "AI Landing Page Builder",
                                        desc: "Ideal for campaigns, lead capture, and product launches."
                                    },
                                    {
                                        icon: "🎨",
                                        title: "Portfolio Website Generator",
                                        desc: "Creatives and students can showcase work in minutes."
                                    },
                                    {
                                        icon: "💼",
                                        title: "No-Code Web Page Creator",
                                        desc: "Build professional pages for small businesses quickly."
                                    },
                                    {
                                        icon: "📅",
                                        title: "Event & Special Pages",
                                        desc: "Thank you pages, coming soon pages, and event sites—done instantly."
                                    },
                                    {
                                        icon: "📊",
                                        title: "A/B Testing for Marketing",
                                        desc: "Test multiple versions without hiring a developer."
                                    }
                                ].map((item, idx) => (
                                    <li key={idx} className="relative flex gap-6">
                                        <div
                                            className={`relative z-10 flex h-10 w-10 flex-shrink-0 items-center justify-center rounded-full ${isDark ? "bg-slate-800" : "bg-white"
                                                } ring-2 ring-indigo-500 text-lg`}
                                        >
                                            {item.icon}
                                        </div>
                                        <div>
                                            <h3
                                                className={`text-lg font-semibold ${isDark ? "text-white" : "text-slate-900"
                                                    }`}
                                            >
                                                {item.title}
                                            </h3>
                                            <p className={isDark ? "text-slate-300" : "text-slate-600"}>
                                                {item.desc}
                                            </p>
                                        </div>
                                    </li>
                                ))}
                            </ol>
                        </div>

                    </div>
                </section>



                <section
                    id="access-anywhere"
                    className={`py-20 relative overflow-hidden ${isDark
                        ? "bg-gradient-to-b from-slate-900 via-slate-900 to-slate-800"
                        : "bg-gradient-to-b from-slate-100 via-slate-100 to-white"
                        }`}
                >
                    <div className="absolute inset-0">
                        <div
                            className={`absolute top-1/2 left-1/2 -translate-x-1/2 w-[800px] h-[800px] rounded-full blur-3xl ${isDark ? "bg-indigo-500/20" : "bg-indigo-400/10"
                                }`}
                        ></div>
                    </div>

                    <div className="relative max-w-6xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
                        <h2
                            className={`text-3xl md:text-4xl font-extrabold tracking-tight ${isDark ? "text-white" : "text-slate-900"
                                }`}
                        >
                            Access Anywhere, Anytime
                        </h2>
                        <p
                            className={`mt-4 text-lg max-w-2xl mx-auto ${isDark ? "text-slate-300" : "text-slate-600"
                                }`}
                        >
                            Your pages are always within reach — edit, preview, and manage them seamlessly from any device.
                        </p>

                        <div className="mt-12 grid grid-cols-1 sm:grid-cols-3 gap-8">
                            {[
                                { icon: "📂", title: "Dashboard Access", desc: "View & manage all your pages from one central place." },
                                { icon: "✏️", title: "Re-edit Anytime", desc: "Apply new prompts to improve or update existing pages instantly." },
                                { icon: "🌐", title: "Preview or Download", desc: "See your page live or download the full HTML/CSS at any time." }
                            ].map((card, i) => (
                                <div
                                    key={i}
                                    className={`p-6 rounded-2xl backdrop-blur-xl border transition ${isDark
                                        ? "bg-white/5 border-white/10 hover:bg-white/10"
                                        : "bg-white border-slate-200 hover:bg-slate-50"
                                        }`}
                                >
                                    <div className="text-3xl mb-4">{card.icon}</div>
                                    <h3
                                        className={`text-lg font-semibold ${isDark ? "text-white" : "text-slate-900"
                                            }`}
                                    >
                                        {card.title}
                                    </h3>
                                    <p
                                        className={`mt-2 ${isDark ? "text-slate-300" : "text-slate-600"
                                            }`}
                                    >
                                        {card.desc}
                                    </p>
                                </div>
                            ))}
                        </div>

                        <button
                            // onClick={() => {
                            //     const token = localStorage.getItem("auth_token");
                            //     if (token) {
                            //         router.push(`/`)
                            //     } else {
                            //         setModalOpen(true);
                            //     }
                            // }}
                            onClick={handleAuthClick}
                            className="mt-12 inline-flex items-center justify-center px-6 py-3 rounded-xl font-semibold shadow-lg bg-gradient-to-r from-indigo-500 to-violet-600 text-white hover:shadow-xl transition cursor-pointer"
                        >
                            Start Managing Your Pages
                        </button>
                    </div>
                </section>

                <LandingPageHeader isDark={isDark} setIsDark={setIsDark} setIsMobile={setIsMobile} isMobile={isMobile} setModalOpen={setModalOpen} />

                <section
                    id="try-it-today"
                    className={`py-16 border-t ${isDark
                        ? "bg-slate-900 border-slate-800"
                        : "bg-white border-slate-200"
                        }`}
                >
                    <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
                        <h2
                            className={`text-3xl md:text-4xl font-extrabold ${isDark ? "text-white" : "text-slate-900"
                                }`}
                        >
                            Try It Today – Start Building with Just One Prompt
                        </h2>
                        <p
                            className={`mt-4 text-lg ${isDark ? "text-slate-300" : "text-slate-600"
                                }`}
                        >
                            Create your first AI-powered website in minutes. No code, no stress — just your words.
                        </p>

                        <div className="mt-6 flex items-center justify-center gap-2 text-yellow-500">
                            ⭐⭐⭐⭐⭐
                            <span
                                className={`ml-2 ${isDark ? "text-slate-400" : "text-slate-500"
                                    }`}
                            >
                                Loved by 100,000+ creators
                            </span>
                        </div>

                        <div className="mt-8 flex flex-col sm:flex-row justify-center gap-4">
                            <button
                                // onClick={(e) => {
                                //     e.preventDefault(); // prevent default anchor navigation
                                //     const token = localStorage.getItem("auth_token");
                                //     if (token) {
                                //         router.push(`/`)
                                //     } else {
                                //         setModalOpen(true);
                                //     }
                                // }}
                                onClick={handleAuthClick}
                                className="px-8 py-4 rounded-xl bg-gradient-to-r from-indigo-500 to-violet-600 text-white font-semibold shadow-lg hover:shadow-xl transition"
                            >
                                👉 Start building for free
                            </button>
                        </div>

                    </div>
                </section>
                <LandingPageFooter isDark={isDark} />
            </div>

            <SignupModal isOpen={isModalOpen} onClose={() => setModalOpen(false)} isDark={isDark} showLoadingGoogleLOgin={showLoadingGoogleLOgin} setShowLoadingGoogleLogin={setShowLoadingGoogleLogin} />

        </div>
    );
    return design;
}
